
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qui-som",
      function () {
        return require("private-next-pages/qui-som.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qui-som"])
      });
    }
  